import { Component, Input } from "@angular/core";

@Component({
	selector: "sub-title",
	template:
		'<h3 [innerHTML]="title" [style.direction]="textDirection" [style.fontSize]="fontSize" ></h3>',
})
export class SubTitleDirective {
	@Input() public title: string;
	@Input() public textDirection: string;
	@Input() public fontSize: string;

	constructor() {}
}
